import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

const savedLang =
  localStorage.getItem("language") ||
  (navigator.language ? navigator.language.split("-")[0] : null) ||
  "en";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: savedLang, // <-- hier direkt setzen
    fallbackLng: "en",
    load: "languageOnly", // "de-DE" → "de"
    supportedLngs: ["en", "de", "fr", "es", "it"],
    interpolation: { escapeValue: false },
    defaultNS: "components",
    ns: ["components", "pages"],
    backend: {
      loadPath: "/texts/{{lng}}/{{ns}}.json",
      // "?v=<build>": a new version never gets stale cached texts
      // (which would show raw keys like "CardStackCalendar.freeUntil")
      queryStringParams: { v: __APP_BUILD_ID__ },
    },
    react: { useSuspense: true },
  });

export default i18n;
